import {useCallback, useEffect, useState} from "react";
import PropTypes from "prop-types";
import GenericDialog from "components/ui/dialogs/generic-dialog/GenericDialog";
import {Button, Grid, makeStyles, Typography} from "@material-ui/core";
import RichiestaInviataDialog
    from "../../../../../../shared/components/dialogs/richiesta-inviata-dialog/RichiestaInviataDialog";
import LimitedCharactersInput from "components/ui/inputs/limited-characters-input/LimitedCharactersInput";
import DefaultSelect from "../../../../../ui/inputs/selects/default-select/DefaultSelect";
import * as actions from "../../../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {createNote, simsToIccIdAndMsisdnList} from "../../../../../../shared/utils/utils";
import ButtonWithProgress from "../../../../../ui/buttons/button-with-progress/ButtonWithProgress";

const useStyles = makeStyles(() => ({
    formControl: {
        width: "100%",
    }
}));
const ImpostazioniAPNDialog = ({
                                   handleDialogClose,
                                   ...props
                               }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const prodottoId = props.isSim ? "1" : null;

    const [limitedCharactersText, setLimitedCharactersText] = useState("");
    const [openRichiestaInviata, setOpenRichiestaInviata] = useState(false);
    const [selectValue, setSelectValue] = useState("");

    const userClaims = useSelector(state => state.authReducer.userClaims);
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany);
    const categoriaMenuItems = useSelector(state => state.serviceRequestReducer.segnalazione.categoria);
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading);
    const errorReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.error);
    const activeServiceRequest = useSelector(state => state.simReducer.activeServiceRequest);

    const closeDialog = useCallback(() => {
        handleDialogClose();
        dispatch(actions.clearSegnalazione())
    }, [handleDialogClose, dispatch])

    useEffect(() => {
        if (activeServiceRequest.value) {
            closeDialog();
        }

        dispatch(actions.getCategoriesInSegnalazione(
                selectedCompany.integrationId,
                selectedCompany.livelloDiAssistenzaId,
                props.screenCode,
                false,
                prodottoId
            )
        );
    }, [
        activeServiceRequest.value, closeDialog, dispatch, props.screenCode,
        selectedCompany.integrationId, selectedCompany.livelloDiAssistenzaId
    ])

    const handleInviaClick = () => {
        const index = categoriaMenuItems.findIndex(menuItem => menuItem.value === selectValue);
        const categoryName = categoriaMenuItems[index].text;
        let simIccIdList = simsToIccIdAndMsisdnList(props.sims);
        const note = createNote(limitedCharactersText, categoryName)
        dispatch(actions.submitReportInSegnalazione(
            selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId,
            props.screenCode,
            userClaims.uid,
            selectValue,
            "",
            "",
            limitedCharactersText,
            "",
            simIccIdList,
            note
        ));
        setOpenRichiestaInviata(true);
        dispatch(actions.clearSegnalazione())
    }


    const handleDialogCloseButton = () => {
        props.handleDialogCloseButton();
        dispatch(actions.clearSegnalazione())
    }

    const textChanged = (text) => {
        setLimitedCharactersText(text);
    };

    const handleRichiestaInviataButton = () => {
        setOpenRichiestaInviata(false);
        closeDialog()
    }

    const handleRichiestaCloseButton = () => {
        setOpenRichiestaInviata(false);
        closeDialog()
    }

    const handleCategoryChange = (event) => {
        setSelectValue(event.target.value);
    }

    const dialogContent = (
        <>
            <Typography variant="h5">{props.data.title}</Typography>
            <Typography className="pb-20" variant="body2">
                {props.data.subtitle}
            </Typography>
            <Grid container className="mt-35">
                <Grid item xs={12} md={3}>
                    <Typography className="mt-24 mb-8" variant="subtitle2">
                        {props.data.selectLabel} *
                    </Typography>
                </Grid>
                <Grid item xs={12} md={9}>
                    <DefaultSelect label={props.data.selectPlaceholder}
                                   menuItems={categoriaMenuItems}
                                   value={selectValue}
                                   handleOnChange={handleCategoryChange}
                                   formControlStyle={classes.formControl}/>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} md={3}>
                    <Typography className="my-12" variant="subtitle2">
                        Dettaglio richiesta
                    </Typography>
                </Grid>
                <Grid item xs={12} md={9}>
                    <LimitedCharactersInput label={"Descrivi qui la tua richiesta"} textChanged={textChanged}
                                            characterLimit={props.characterLimit}/>
                </Grid>
            </Grid>
            {openRichiestaInviata && !loadingReportProblem && !errorReportProblem ? (
                <RichiestaInviataDialog
                    open={openRichiestaInviata}
                    handleDialogClose={handleRichiestaInviataButton}
                    handleRichiestaCloseButton={handleRichiestaCloseButton}
                />
            ) : null}
        </>
    );

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button onClick={closeDialog} color="primary" variant="outlined">
                <div className="align-center-x px-16">Annulla</div>
            </Button>

            <ButtonWithProgress handleClick={handleInviaClick}
                                text={"Invia"}
                                disabled={limitedCharactersText.length === 0 || selectValue === ""}
                                loading={loadingReportProblem}/>
        </Grid>
    );

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={closeDialog}
            handleDialogCloseButton={handleDialogCloseButton}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
            loading={props.isSim ? activeServiceRequest.loading : null}
        />
    );
};

ImpostazioniAPNDialog.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    isSim: PropTypes.bool
};

ImpostazioniAPNDialog.defaultProps = {
    sims: [],
    screenCode: null,
    characterLimit: 1000,
    isSim: false
};


export default ImpostazioniAPNDialog;
